import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchInstanceById = async (id?: number | null) => {
	if (!id) return Promise.reject("No id");

	const url = `/observations/instances/${id}/`;

	const response = await cmsClient.get<IFormInstance>(url);
	return response.data;
};

interface Options {
	enabled?: boolean;
	onSuccess?: (data: IFormInstance) => void;
}

const useFormInstance = (
	formInstanceId?: number | null,
	options: Options = { enabled: true }
) => {
	const query = useQuery(
		["formInstance", formInstanceId],
		() => fetchInstanceById(formInstanceId),
		options
	);

	return query;
};

export default useFormInstance;
